import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getRecognizeAudienceInsights } from "./get-recognize-audience-insights";
import { getRecognizeExportCount } from "./get-recognize-export-count";
import { getRecognizeProfileDetails } from "./get-recognize-profile-details";
import { getRecognizeVipOrders, getRecognizeVips } from "./get-recognize-vips";
import {
  getRecognizeActions,
  saveRecognizeActions,
  sendRecognizeTestEmail,
} from "./recognize-actions";
import {
  getRecognizeOrderTags,
  getRecognizeRunFilters,
  getRecognizeSalesChannels,
  saveRecognizeRunFilters,
} from "./recognize-run-filters";
import { searchRecognizeAudienceProductTitles } from "./search-recognize-audience-product-titles";
import { searchRecognizeAudienceProducts } from "./search-recognize-audience-products";

export const recognizeRpcDefinition = {
  getRecognizeOrderTags,
  getRecognizeRunFilters,
  getRecognizeSalesChannels,
  saveRecognizeRunFilters,
  getRecognizeActions,
  saveRecognizeActions,
  sendRecognizeTestEmail,
  getRecognizeAudienceInsights,
  searchRecognizeAudienceProducts,
  searchRecognizeAudienceProductTitles,
  getRecognizeExportCount,
  getRecognizeVips,
  getRecognizeVipOrders,
  getRecognizeProfileDetails,
};

export type RecognizeRpcDefinition = InferRpcDefinition<
  typeof recognizeRpcDefinition
>;
